import React from "react";
import {animated} from "react-spring";
import * as PropTypes from "prop-types";
import copy from "copy-to-clipboard";

export class Supporters extends React.Component {
    render() {
        return <section id="supporters" className="section-with-bg">
            <animated.div style={this.props.style} className="container" data-aos="fade-up">
                <div className="section-header">
                    <h2>Sponsors</h2>
                </div>
                {!this.props.tbd &&
                <animated.div style={this.props.style} className="row no-gutters supporters-wrap clearfix">
                    {this.props.sponsors && this.props.sponsors.map((sponsor) =>
                    <div className="col-lg-3 col-md-4 col-xs-6">
                        <div className="supporter-logo">
                            <img src={sponsor.imgSrc} className="img-fluid" alt="" onClick={
                                ()=>{
                                    if(sponsor.href){
                                        window.location = sponsor.href
                                    }
                                }
                            }/>
                        </div>
                    </div>
                    )}
                </animated.div>
                }
                <animated.div style={this.props.style} className="row">
                    <p>2022, BSidesCT is hosting its 8th annual community-driven information
                        security conference.</p>
                    <p>Next year our event includes presentations by information security experts, our thoughtfully
                        crafted capture the flag learning contest, interactive workshops and more.</p>
                    <p>Your organization is invited and can help us make this possible. Please email&nbsp;
                        <a href={"/"} onClick={(e)=>{
                            e.preventDefault();
                            copy(this.props.email);
                            alert("Copied "+this.props.email+" to clipboard")
                        }}>{this.props.email}</a> for additional information regarding sponsorship opportunities.</p>
                </animated.div>
            </animated.div>

        </section>;
    }
}

Supporters.propTypes = {style: PropTypes.any, imageHrefs: PropTypes.array, email: PropTypes.string};
